import { Box } from '@palmetto/palmetto-components';

import { MilestoneLabels, MilestoneType, SabalOrganizationalEvents } from 'types';

import { Diffs } from './Diffs';
import EventBy from './EventBy';

const TOP_LEVEL_FIELDS = ['enabled', 'reviewPriorityTier'];

// The milestones whose submission/resubmission budgets are shown in the QC priority history diff.
const SLA_MILESTONES = [MilestoneType.noticeToProceed, MilestoneType.install, MilestoneType.activation];

const SabalOrganizationReviewSlaSettingsUpdated = ({ event }: { event: any }) => {
  const prev = event.data?.previousReviewSlaSettings;
  const next = event.data?.newReviewSlaSettings;
  const isCreate = prev === null || prev === undefined;
  const isDisable = event.eventType === SabalOrganizationalEvents.sabalOrganizationReviewSlaSettingsDisabled;

  const diff = TOP_LEVEL_FIELDS.reduce<Record<string, { from: any; to: any }>>((acc, key) => {
    if (prev?.[key] !== next?.[key]) {
      acc[key] = { from: prev?.[key] ?? '—', to: next?.[key] ?? '—' };
    }
    return acc;
  }, {});

  SLA_MILESTONES.forEach((milestone) => {
    const prevHours = prev?.slaBusinessHoursByMilestone?.[milestone];
    const nextHours = next?.slaBusinessHoursByMilestone?.[milestone];
    (['submission', 'resubmission'] as const).forEach((budget) => {
      const from = prevHours?.[budget];
      const to = nextHours?.[budget];
      if (from !== to) {
        diff[`${MilestoneLabels[milestone]} ${budget} hours`] = { from: from ?? '—', to: to ?? '—' };
      }
    });
  });

  const action = isDisable ? 'disabled' : isCreate ? 'created' : 'updated';

  return (
    <Box display="block">
      <EventBy event={event} /> {action} QC priority settings
      <Diffs diff={diff} hiddenProperties={[]} />
    </Box>
  );
};

export default SabalOrganizationReviewSlaSettingsUpdated;
